import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import { Box, Text } from '@percent/lemonade'
import { AuthView } from '@percent/admin-dashboard/app/auth/authview/AuthView'
import LoggedInAnotherDevice from '@percent/admin-dashboard/common/assets/images/logged-another-device.png'
import { PercentButton } from '@percent/admin-dashboard/common/components'
import styles from './ExpiredSessionHandle.module.scss'

export function ExpiredSessionHandle() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const redirectToLogin = () => navigate(`/login${location.search}`)

  return (
    <AuthView adminLogo>
      <Box className={styles.container}>
        <img className={styles.sessionImage} alt="auth-world-screen" src={LoggedInAnotherDevice} />
        <Text className={styles.loggedInText}>{t('typography.sessionHasExpired')}</Text>
        <Text className={styles.loggedOutText}>{t('typography.loggedOutFromThisSession')}</Text>
        <PercentButton
          className={styles.loginButton}
          fullWidth
          data-testid="auth-active-button"
          title={t('button.logIn')}
          onClick={redirectToLogin}
        />
      </Box>
    </AuthView>
  )
}
